import sharedDataApi from "../api/sharedDataApi";

export const executeProductionOperations = async (actionItem, recipeId, productData, recipeData, recipeInputFields) => {
  console.log('Starting Move to Production Operations');
  console.log('Data:', { productId: actionItem.ProductId, modelNumber: actionItem.ModelNumber });

  // Call generateAmsData Lambda
  try {
    console.log('Calling generateAmsData Lambda for ProductId:', actionItem.ProductId);

    const params = {
      productInfo: JSON.stringify(productData),
      recipe: JSON.stringify(recipeData),
      userInput: recipeInputFields[0].Input,
      state: productData.State,
      downloadSd: true,
    };
    
    console.log('generateAmsData parameters:', params);

    const amsResult = await sharedDataApi.generateAmsData(params);

    console.log('AMS Lambda Response:', amsResult);
    // Return the full response for status code checking in frontend
    return amsResult;
  } catch (error) {
    console.error('Error calling generateAmsData Lambda:', error);
    // Return error object for frontend to handle
    return { error: true, details: error };
  }
};